/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_History_HeadingInputs */



/**
* | output |
* | --- |
* | "This project" |
*
* @param {Assistant_History_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_history_heading = /** @type {((inputs?: Assistant_History_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_History_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Projekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这个项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプロジェクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस प्रोजेक्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Este projeto")
	return /** @type {LocalizedString} */ ("This project")
});